import { updateAccountData } from './helpers';
import { fetchGamedayAccount } from './actions';
import getProvinceMapForCountry from '../util/getProvinceMap';

export const defaultState = {};

const gamedayAccount = (state = defaultState, action) => {
  switch (action.type) {
    case fetchGamedayAccount.event.success:
      return updateAccountData({
        ...action.payload.response,
        provinces: getProvinceMapForCountry(action.payload.response.contactCountryCode)
      });
    case fetchGamedayAccount.event.error:
      return {};
    default:
      return state;
  }
};

export default gamedayAccount;
